export function filter<T, U extends T>(predicate: (value: T) => value is U): (array: T[]) => U[]
export function filter<T>(predicate: (value: T) => boolean): (array: T[]) => T[]

export function filter<T>(predicate: (value: T) => unknown) {
  return function (array: T[]) {
    return array.filter(predicate)
  }
}
